import { Link } from "react-router-dom";
import { Lock } from "lucide-react";
import { useLang, scrollToId } from "@/i18n";

const Footer = () => {
  const { t } = useLang();

  return (
    <footer className="border-t border-[#EBDDC6]/70 bg-[#FDF6EC]" data-testid="footer">
      <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8">
        <div className="flex flex-col items-start justify-between gap-10 lg:flex-row lg:items-end">
          <div>
            <p className="font-display text-3xl font-semibold text-[#3B2A1E] sm:text-4xl">
              Les Retrouvailles <span className="italic text-[#E07A2B]">de la Douce</span>
            </p>
            <p className="mt-3 font-display text-lg italic text-[#A9761F]">{t.footer.tagline}</p>
            <p className="mt-4 text-sm text-[#A08B74]">Av. Clemenceau 34 · 1070 Anderlecht, Bruxelles</p>
            <a href="tel:+32470313554" className="mt-1 block text-sm text-[#7A6753] transition-colors hover:text-[#E07A2B]">+32 470 31 35 54</a>
            <p className="mt-3 text-xs text-[#A08B74]" data-testid="footer-partner">
              {t.footer.partner}{" "}
              <a href="https://noldgo.com/restaurants/c6369716-98f1-4462-a9e4-2b9c24324a10" target="_blank" rel="noopener noreferrer" className="font-semibold text-[#A9761F] transition-colors hover:text-[#E07A2B]" data-testid="footer-partner-link">
                Noldgo.com
              </a>
            </p>
          </div>
          <div className="flex flex-col gap-2 text-sm">
            {[
              ["histoire", t.nav.story],
              ["carte", t.nav.menu],
              ["galerie", t.nav.gallery],
              ["reservation", t.nav.reservation],
              ["infos", t.nav.info],
            ].map(([id, label]) => (
              <button key={id} onClick={() => scrollToId(id)} data-testid={`footer-link-${id}`}
                className="text-left text-[#A08B74] transition-colors hover:text-[#E07A2B]">
                {label}
              </button>
            ))}
          </div>
        </div>
        <div className="mt-12 flex items-center justify-between border-t border-[#EBDDC6]/60 pt-6 text-xs text-[#A08B74]">
          <p>© {new Date().getFullYear()} Les Retrouvailles de la Douce — {t.footer.rights}</p>
          <Link to="/admin" className="inline-flex items-center gap-1.5 transition-colors hover:text-[#A9761F]" data-testid="footer-admin-link">
            <Lock size={12} /> {t.footer.admin}
          </Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
